import ReactDOM from 'react-dom';
export var unstable_batchedUpdates = ReactDOM.unstable_batchedUpdates;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-query/es/react/reactBatchedUpdates.js
// module id = 1530
// module chunks = 0